<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            
            <el-tab-pane label="校币清单" name="first">
                <child1 v-if="activeName == 'first'"></child1>
            </el-tab-pane>

            <el-tab-pane label="学生可兑换分查询" name="second">
                <child2 v-if="activeName == 'second'"></child2>    
            </el-tab-pane>

            <el-tab-pane label="校币兑换" name="three">
                <child3 v-if="activeName == 'three'"></child3>    
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
    import coinListPage from './coinList/list.vue'
    import coinExchangeListPage from './coinExchangeList/list.vue'

    export default {
        name:"coinMain",
        components:{
            child1: coinListPage,
            child2: coinExchangeListPage
        },
        data() {
            return {
                menuName:"",
                activeName: "first",
                title:"校币清单"
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
        },
        methods:{
            handleClick(tab) {
                if(tab.name == "first") {
                    this.activeName = 'first';
                    this.title="校币清单";
                }else if(tab.name == "second") {
                    this.activeName = 'second';
                    this.title="学生可兑换分查询";
                }else if(tab.name == "eight") {
                    this.activeName = 'eight';
                    this.title="校币兑换";
                }else if(tab.name == "three") {
                    this.activeName = 'three';
                    this.title="校币兑换";
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/schoolCoin/coinMain.vue